module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon02-ko-0e87265036d4a77cf1fab108044c0840.png";